import { FilesFolders } from 'constants/files-folders-enum';
import { useApiUploadActions } from 'hooks/upload-actions';
import { useTranslation } from 'react-i18next';

import { DocumentUploadModal } from 'components/DocumentUploadModal/DocumentUploadModal';

const SELFIE_ACCEPT = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export const SupportSelfieUploadModal = ({
  candidate,
  company,
  existingSelfieIds = [],
  visible,
  onUpdate = () => {},
  onClose = () => {},
}) => {
  const { t } = useTranslation();
  const { signUpload, createUpload, deleteUpload } = useApiUploadActions();

  const handleUpload = async uploadData => {
    for (const selfieId of existingSelfieIds) {
      await deleteUpload(selfieId);
    }
    await createUpload(uploadData);
    await onUpdate();
  };

  return (
    <DocumentUploadModal
      visible={visible}
      onClose={onClose}
      onUpload={handleUpload}
      title={t('admin.candidate.components.supportSelfieUpload.uploadSelfie')}
      description={t('admin.candidate.components.supportSelfieUpload.uploadSelfieDescription')}
      onlyUpload={true}
      icon="camera"
      accept={SELFIE_ACCEPT}
      companyId={company?.id}
      modelParams={{
        candidate_id: candidate?.id,
        company_id: company?.id,
      }}
      metadata={{ selfie: true }}
      bucketFolder={FilesFolders.CandidatesApplicationDocuments}
      signUpload={signUpload}
      deleteUpload={deleteUpload}
    />
  );
};
